// LoginV2.styles.js — layout for the redesigned login. Colors come from SB_COLORS (theme).
import styled from "styled-components";
import SbForm from "uiCore/SbForm/SbForm";
import { SB_HEADING_FONT_FAMILY } from "theme/SbThemeV2";

export const LoginPageStyled = styled.div`
  min-height: 100vh;
  display: flex;
  background: ${p => p.theme?.colors?.loginGradient};
  color: ${p => p.theme?.colors?.white};
  padding: 0 max(24px, calc((100vw - 1200px) / 2));
`;

export const LoginLeftStyled = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 0;
  @media (max-width: 992px) { padding: 40px 24px; }
`;

export const LoginRightStyled = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 992px) { display: none; }
`;

export const LoginPageImageStyled = styled.img`
  width: 100%;
  max-width: 620px;
`;

export const LogoStyled = styled.img`
  height: 38px;
  align-self: flex-start;
  margin-bottom: 48px;
`;

export const HeadingStyled = styled.h1`
  color: ${p => p.theme?.colors?.white};
  font-family: ${SB_HEADING_FONT_FAMILY};
  font-size: clamp(32px, 4vw, 52px);
  font-weight: 400;
  line-height: 1.12;
  max-width: 520px;
  margin: 0 0 40px;
`;

export const FormStyled = styled(SbForm)`
  max-width: 440px;

  .ant-input {
    background: transparent;
    color: ${p => p.theme?.colors?.white};
    border-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.08);
  }
  .ant-input::placeholder { color: rgba(255, 255, 255, 0.6); }


  .ant-input:-webkit-autofill {
    -webkit-text-fill-color: ${p => p.theme?.colors?.white};
    transition: background-color 9999s ease-in-out 0s;
  }

  .recaptcha-wrapper {
    width: fit-content;
    // border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    // box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.08);
    overflow: hidden;
  }
  .recaptcha-wrapper iframe {
    mix-blend-mode: screen;
  }
`;

export const FieldStyled = styled.div`
  margin-bottom: 18px;
`;

// Two fields side by side (e.g. First/Last name). Children split the row evenly.
export const FieldRowStyled = styled.div`
  display: flex;
  gap: 16px;
  & > * {
    flex: 1;
    min-width: 0;
  }
`;

export const LabelStyled = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: ${p => p.theme?.colors?.white};
`;  

export const LinksRowStyled = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 22px;
  font-size: 14px;
  color: ${p => p.theme?.colors?.white};
`;

export const LinkStyled = styled.a`
  color: ${p => p.theme?.colors?.accentMint};
  cursor: pointer;
  font-weight: 500;
`;

export const MessageStyled = styled.p`
  margin: 6px 0 0;
  font-size: 12px;
  color: ${p => (p.$success ? p.theme?.colors?.accentMint : "#FFD2D2")};
`;
